import { memo } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

interface Props {
  handleBlur: (event: any) => void;
  setFieldValue: (field: string, value: any) => void;
  label: string;
  name: string;
  checkboxClassName?: string; // tailwind utility classes
  checked?: boolean;
  isReview?: boolean;
  onChange?: (checked: boolean) => void;
}
function CustomCheckBox({
  handleBlur,
  setFieldValue,
  label,
  checkboxClassName,
  name,
  checked,
  isReview,
  onChange
}: Props) {
  return (
    <FormControlLabel
      name={name}
      onBlur={handleBlur}
      classes={{
        label: "!font-montserrat !text-sm !font-medium !ml-2",
        root: "!flex !items-start"
      }}
      control={
        <Checkbox
          checked={checked}
          // onChange={(e) => setFieldValue(name, e.target.checked)}
          onChange={(e) => {
            setFieldValue(name, e.target.checked);
            if (onChange) onChange(e.target.checked);
          }}
          disableRipple
          className="border-2"
          disabled={isReview} // Set the disabled attribute based on isReview prop
          classes={{
            root: `!flex !items-start !p-0 !ml-2 ${checkboxClassName}`,
            checked: "!text-outrageousGreen !bg-white"
          }}
        />
      }
      label={label}
    />
  );
}

CustomCheckBox.defaultProps = {
  checkboxClassName: "",
  checked: false,
  isReview: false,
  onChange: () => {}
};

export default memo(CustomCheckBox);
